import BankAccountFormDialog from './BankAccountFormDialog';

export default BankAccountFormDialog;
